import React from 'react';
import {useCurrentUserContext} from '../../../context/CurrentUserProvider';

export default function Logout() {
  const currentUser = useCurrentUserContext();

  const handleLogout = async () => {
    if (!currentUser.loggedIn) return;
    await currentUser.logout();
  };

  return (
    <div>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
}
